import { render, staticRenderFns } from "./new_digital_asset2.vue?vue&type=template&id=ab5fba4a&scoped=true"
import script from "./new_digital_asset2.vue?vue&type=script&lang=js"
export * from "./new_digital_asset2.vue?vue&type=script&lang=js"
import style0 from "./new_digital_asset2.vue?vue&type=style&index=0&id=ab5fba4a&prod&scoped=true&lang=css"
import style1 from "./new_digital_asset2.vue?vue&type=style&index=1&id=ab5fba4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5fba4a",
  null
  
)

export default component.exports